"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBreakpoints = exports.BREAKPOINT_SIZES = void 0;
const useMediaQuery_1 = require("./useMediaQuery");
exports.BREAKPOINT_SIZES = { sm: 490, md: 768, lg: 1080, xl: 1440 };
/**
 * Hook equivalent of CSS media queries with our
 * [supported breakpoints](https://atlantis.getjobber.com/?path=/docs/design-breakpoints--page).
 */
function useBreakpoints() {
    const { sm, md, lg, xl } = exports.BREAKPOINT_SIZES;
    const extraSmallOnly = (0, useMediaQuery_1.useMediaQuery)(`(max-width: ${sm - 1}px)`);
    const smallAndUp = (0, useMediaQuery_1.useMediaQuery)(`(min-width: ${sm}px)`);
    const mediumAndUp = (0, useMediaQuery_1.useMediaQuery)(`(min-width: ${md}px)`);
    const largeAndUp = (0, useMediaQuery_1.useMediaQuery)(`(min-width: ${lg}px)`);
    const extraLargeAndUp = (0, useMediaQuery_1.useMediaQuery)(`(min-width: ${xl}px)`);
    return {
        smallAndUp,
        mediumAndUp,
        largeAndUp,
        extraLargeAndUp,
        extraSmallOnly,
        smallOnly: smallAndUp && !mediumAndUp,
        mediumOnly: mediumAndUp && !largeAndUp,
        largeOnly: largeAndUp && !extraLargeAndUp,
    };
}
exports.useBreakpoints = useBreakpoints;
